import { handleActions } from 'redux-actions';
import { PARTITION, actionTypes, ACTION_PREFIX } from './constants';
import { getActionOptions } from '../../lib/reduxActionsUtils';

export interface ReduxState {
  step: number;
  validityInSeconds: number;
  mobileNumber: string;
}

const initialState: ReduxState = {
  step: 0,
  mobileNumber: '',
  validityInSeconds: 0,
};

const reducer = handleActions(
  {
    [actionTypes.GENERATE_AUTH_CODE_FULFILLED]: (state: any, { payload }) => ({
      ...state,
      step: 1,
      validityInSeconds: payload.validityInSeconds,
      mobileNumber: payload.mobileNumber,
    }),
    [actionTypes.SET_LOGIN_STEP]: (state: any, { payload }) => ({
      ...state,
      step: payload,
    }),
  },
  initialState,
  getActionOptions(ACTION_PREFIX)
);

export default {
  [PARTITION]: reducer,
};
